import request from "@/utils/request";

// 获取省
export function regionProvince() {
  return request({
    url: `/system/region/province`,
    method: "get",
  });
}

// 获取市
export function regionCity(id) {
  return request({
    url: `/system/region/city/${id}`,
    method: "get",
  });
}

// 获取区
export function regionCounty(id) {
  return request({
    url: `/system/region/county/${id}`,
    method: "get",
  });
}
